export const DOC_LABELS = {
  class_12_certificate: 'Class 12 Certificate',
  class_12_marksheet: 'Class 12 Marksheet',
  class_10_certificate: 'Class 10 Certificate',
  class_10_marksheet: 'Class 10 Marksheet',
  id_proof: 'Student ID Proof',
  id_proof_primary: 'Student ID 1 (PR / Passport)',
  id_proof_secondary: 'Student ID 2 (DL / BCeID)',
  photo: 'Student Photograph',
  study_permit: 'Study Permit',
  english_proficiency_test: 'English Proficiency Test',
  diploma_transcript: 'Diploma / Transcript',
};

export const UPLOADABLE_DOC_KEYS = Object.keys(DOC_LABELS).filter((k) => k !== 'id_proof');

export const docLabel = (key) => DOC_LABELS[key] || key.replace(/_/g, ' ');
